import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import {
  TPersonalDataPreviewDocumentRequest,
  TDocumentPreviewPersonalDataRequest,
  TDocumentPreviewPersonalDataResponse,
} from '~/store/processing-personal/types.ts';
import { buildPreviewHtmlUrl, htmlContent } from '~/helpers/htmlContent';
import { safeWindowOpen } from '~/helpers/safeUrlOpen.ts';

export const documentPreviewPersonalData = createAsyncThunk<
  TDocumentPreviewPersonalDataResponse,
  TDocumentPreviewPersonalDataRequest
>(
  'processingPersonal/documentPreviewSubmit',
  async ({ applicationId, applicationDocumentId }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/personal-data/public/personal-data/applications/${applicationId}/documents/${applicationDocumentId}/preview`
      );

      const blob = response.data;
      const fileURL = URL.createObjectURL(blob);

      return {
        fileURL,
        appId: applicationId,
        docId: applicationDocumentId,
      };
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const revokeDocumentPreviewPersonalData = createAsyncThunk<
  TDocumentPreviewPersonalDataResponse,
  TDocumentPreviewPersonalDataRequest
>(
  'processingPersonal/documentPreviewRevoke',
  async ({ applicationId, applicationDocumentId }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/personal-data/public/personal-data/revoke/applications/${applicationId}/documents/${applicationDocumentId}/preview`
      );

      const blob = response.data;
      const fileURL = URL.createObjectURL(blob);

      return {
        fileURL,
        appId: applicationId,
        docId: applicationDocumentId,
      };
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const documentPreviewPersonalDataTable = createAsyncThunk<
  TDocumentPreviewPersonalDataResponse,
  TDocumentPreviewPersonalDataRequest
>(
  'processingPersonal/documentPreviewTableSubmit',
  async ({ applicationId, applicationDocumentId }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/personal-data/personal-data/applications/${applicationId}/documents/${applicationDocumentId}/preview`
      );

      const blob = response.data;
      const fileURL = URL.createObjectURL(blob);

      return {
        fileURL,
        appId: applicationId,
        docId: applicationDocumentId,
      };
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const revokeDocumentPreviewPersonalDataTable = createAsyncThunk<
  TDocumentPreviewPersonalDataResponse,
  TDocumentPreviewPersonalDataRequest
>(
  'processingPersonal/documentPreviewTableRevoke',
  async ({ applicationId, applicationDocumentId }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/personal-data/personal-data/revoke/applications/${applicationId}/documents/${applicationDocumentId}/preview`
      );

      const blob = response.data;
      const fileURL = URL.createObjectURL(blob);

      return {
        fileURL,
        appId: applicationId,
        docId: applicationDocumentId,
      };
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const previewDocumentSubmit = createAsyncThunk<void, TPersonalDataPreviewDocumentRequest>(
  'processingPersonal/documentPreviewIIT',
  async ({ applicationId, idDoc, fileName }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/personal-data/public/personal-data/applications/${applicationId}/documents/${idDoc}/preview`
      );
      const fileURL = URL.createObjectURL(data);

      const htmlBlob = new Blob([htmlContent(fileURL, fileName)], { type: 'text/html' });
      const htmlURL = URL.createObjectURL(htmlBlob);
      const previewURL = buildPreviewHtmlUrl(htmlURL, fileName);

      safeWindowOpen(previewURL);

      setTimeout(() => URL.revokeObjectURL(htmlURL), 2000);
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const revokePreviewDocumentSubmit = createAsyncThunk<
  void,
  TPersonalDataPreviewDocumentRequest
>(
  'processingPersonal/documentPreviewIITRevoke',
  async ({ applicationId, idDoc, fileName }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/personal-data/public/personal-data/revoke/applications/${applicationId}/documents/${idDoc}/preview`
      );
      const fileURL = URL.createObjectURL(data);

      const htmlBlob = new Blob([htmlContent(fileURL, fileName)], { type: 'text/html' });
      const htmlURL = URL.createObjectURL(htmlBlob);
      const previewURL = buildPreviewHtmlUrl(htmlURL, fileName);

      safeWindowOpen(previewURL);

      setTimeout(() => URL.revokeObjectURL(htmlURL), 2000);
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
